import { createApp } from 'vue'
import { createPinia } from 'pinia'
//@ts-ignore
import VueApexCharts from 'vue3-apexcharts'

import App from './App.vue'
import router from './router'
import hookupFeather from '@/config/feather'
import hookupBuefy from '@/config/buefy'
import { Auth0 } from '@/config/auth'
import { VueQueryPlugin } from '@tanstack/vue-query'
import { queryConfig } from './config/query'
// @ts-ignore
import errorTracking from '@/config/sentry'
import { VueIntercom } from 'vue-intercom'
import { i18n } from './config/i18n'

declare global {
  interface Window {
    Cohere: any
    // @ts-ignore
    heap: any
  }
}

export const app = createApp(App)

app.use(i18n)
app.use(VueApexCharts)
app.use(errorTracking, {
  dsn: import.meta.env.VITE_VUE_APP_SENTRY_DSN,
  environment: import.meta.env.VITE_VUE_APP_ENV,
  release: `workforce_intelligence/${__VUE_APP_VERSION__}`,
  role: 'subscriber',
  router: router
})
hookupFeather(app)
hookupBuefy(app)
app.use(VueQueryPlugin, queryConfig)
app.use(createPinia())
app.use(router)
//@ts-ignore
app.use(Auth0)
if (import.meta.env.VITE_VUE_APP_INTERCOM_KEY) {
  app.use(VueIntercom, {
    APP_ID: import.meta.env.VITE_VUE_APP_INTERCOM_KEY,
    delayedBoot: true
  })
}
console.info(`WI Version: ${__VUE_APP_VERSION__}`)
console.info(`Git revision: ${__VUE_APP_HASH__}`)
app.mount('#app')
